import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { AdyenPaymentMethodType } from "@faire/retailer-visitor-shared/components/AddPaymentMethods/consts";
import { lazy } from "react";
var _obj;
export var lazyIcons = (_obj = {}, _define_property(_obj, AdyenPaymentMethodType.SEPA, /*#__PURE__*/ lazy(function() {
    return import("@faire/web--source/slate/icons/payment-methods/Sepa").then(function(m) {
        return {
            default: m.Sepa
        };
    });
})), _define_property(_obj, AdyenPaymentMethodType.SOFORT, /*#__PURE__*/ lazy(function() {
    return import("@faire/web--source/slate/icons/payment-methods/Klarna").then(function(m) {
        return {
            default: m.Klarna
        };
    });
})), _define_property(_obj, AdyenPaymentMethodType.IDEAL, /*#__PURE__*/ lazy(function() {
    return import("@faire/web--source/slate/icons/payment-methods/Ideal").then(function(m) {
        return {
            default: m.Ideal
        };
    });
})), _define_property(_obj, AdyenPaymentMethodType.BACS, /*#__PURE__*/ lazy(function() {
    return import("@faire/web--source/slate/icons/payment-methods/BACS").then(function(m) {
        return {
            default: m.BACS
        };
    });
})), _define_property(_obj, "cartebancaire", /*#__PURE__*/ lazy(function() {
    return import("@faire/web--source/slate/icons/payment-methods/CB").then(function(m) {
        return {
            default: m.CB
        };
    });
})), _define_property(_obj, "visa", /*#__PURE__*/ lazy(function() {
    return import("@faire/web--source/slate/icons/payment-methods/Visa").then(function(m) {
        return {
            default: m.Visa
        };
    });
})), _define_property(_obj, "mc", /*#__PURE__*/ lazy(function() {
    return import("@faire/web--source/slate/icons/payment-methods/MasterCard").then(function(m) {
        return {
            default: m.MasterCard
        };
    });
})), _define_property(_obj, "amex", /*#__PURE__*/ lazy(function() {
    return import("@faire/web--source/slate/icons/payment-methods/Amex").then(function(m) {
        return {
            default: m.Amex
        };
    });
})), _define_property(_obj, "discover", /*#__PURE__*/ lazy(function() {
    return import("@faire/web--source/slate/icons/payment-methods/Discover").then(function(m) {
        return {
            default: m.Discover
        };
    });
})), _define_property(_obj, "diners", /*#__PURE__*/ lazy(function() {
    return import("@faire/web--source/slate/icons/payment-methods/Diners").then(function(m) {
        return {
            default: m.Diners
        };
    });
})), _define_property(_obj, "ach", /*#__PURE__*/ lazy(function() {
    return import("@faire/web--source/slate/icons/payment-methods/ACH").then(function(m) {
        return {
            default: m.ACH
        };
    });
})), _define_property(_obj, "scheme", /*#__PURE__*/ lazy(function() {
    return import("@faire/web--source/slate/icons/payment-methods/Card").then(function(m) {
        return {
            default: m.Card
        };
    });
})), _define_property(_obj, "fairepay", /*#__PURE__*/ lazy(function() {
    return import("@faire/web--source/slate/icons/payment-methods/FairePay").then(function(m) {
        return {
            default: m.FairePay
        };
    });
})), _obj);
